import React from 'react';
import { useNavigate } from 'react-router-dom';
import cliente from 'assets/img/2026/ELBB/cliente.png';
import inovacao from 'assets/img/2026/ELBB/inovacao.png';
import asg from 'assets/img/2026/ELBB/asg.png';
import investimentos from 'assets/img/2026/ELBB/investimentos.png';
import cultura from 'assets/img/2026/ELBB/cultura.png';
import './CategoriasParticipantes.scss';

interface CategoriasParticipantesProps {
  categoriaSelecionada?: string;
  /** Quando informado, substitui o comportamento padrão de navegação para `/classificadas-etapa-1-elbb`. */
  onCategoriaChange?: (categoria: string) => void;
  /** Sobrescreve o título padrão da seção. */
  title?: string;
  /** Quando true, renderiza os cards como elementos visuais sem clique ou navegação. */
  readOnly?: boolean;
}

export const CATEGORIAS_ELBB_PERSPECTIVAS = [
  { id: 'clientes', nome: 'Clientes', imagem: cliente },
  { id: 'financeira', nome: 'Financeira', imagem: investimentos },
  { id: 'asg', nome: 'ASG', imagem: asg },
  { id: 'transformacao_digital_processos', nome: 'Transformação digital e processos', imagem: inovacao },
  { id: 'pessoas_cultura', nome: 'Pessoas e Cultura', imagem: cultura },
];

export const CategoriasParticipantes: React.FC<CategoriasParticipantesProps> = ({
  categoriaSelecionada,
  onCategoriaChange,
  title,
  readOnly,
}) => {
  const navigate = useNavigate();

  return (
    <div className="categorias-participantes">
      <h2 className="categorias-participantes__title">
        {title ?? 'Conheça as iniciativas classificadas na Etapa 1'}
      </h2>
      <div className="categorias-participantes__grid">
        {CATEGORIAS_ELBB_PERSPECTIVAS.map((categoria) => {
          if (readOnly) {
            return (
              <div
                key={categoria.id}
                className="categorias-participantes__btn categorias-participantes__btn--readonly"
                aria-label={categoria.nome}
              >
                <img src={categoria.imagem} alt="" aria-hidden="true" />
                <span className="categorias-participantes__nome">{categoria.nome}</span>
              </div>
            );
          }

          const isActive = categoriaSelecionada === categoria.id;
          return (
            <button
              key={categoria.id}
              type="button"
              className={`categorias-participantes__btn${isActive ? ' active' : ''}`}
              onClick={() => {
                if (onCategoriaChange) {
                  onCategoriaChange(categoria.id);
                  return;
                }
                navigate('/classificadas-etapa-1-elbb', { state: { categoria: categoria.id } });
              }}
              aria-pressed={onCategoriaChange ? isActive : undefined}
              aria-label={`Filtrar por ${categoria.nome}`}
            >
              <img src={categoria.imagem} alt="" aria-hidden="true" />
              <span className="categorias-participantes__nome">{categoria.nome}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
